import gql from 'graphql-tag';

// eslint-disable-next-line
export const SSOChangePassword = gql `mutation UpdateAccountPassword($password: AccountChangePassword_String_Input){
  sso_update_account_password(password: $password)
}`;

export const SSOUpdateProfile = gql `mutation UpdateProfile($account: UserDto_String_Input) {
  sso_update_account(account: $account)
}`;



// WEBPACK FOOTER //
// ./src/store/graphql/mutations/user.js